import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ToastProvider } from '@artosera/ui';
import '@artosera/ui/reset.css';
import '@artosera/ui/tokens.css';
import '@artosera/ui/fonts.css';
import '@artosera/ui/base.css';
import './styles/console.css';
import App from './App.js';
import './i18n.js';
import { creerQueryClient } from './lib/queryClient.js';

const racine = document.getElementById('racine');

if (!racine) {
  throw new Error('Élément racine introuvable.');
}

const queryClient = creerQueryClient();

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
